import {PropertyFilterProps, TableProps} from '@amzn/awsui-components-react';
import React from 'react';
import {DynamicExecution, WorkflowExecutionStatus} from '../../../backend/model';
import {DynamicExecutionIdLink} from '../../TableItemLink';
import {prettifyDateUTC} from '../../workflow/date';
import WorkflowStatusIndicator from '../../workflow/WorkflowStatusIndicator';
import { compareOptionalDate } from '../../../utils/sorting';
import { operators } from '../../TableTemplate';
import { PropertyFilterOperator } from '@amzn/awsui-collection-hooks';
import RulesTableEntry from './RulesTableEntry';

export const dynamicExecutionHistoryColumns: TableProps.ColumnDefinition<DynamicExecution>[] = [
    {
        id: 'executionId',
        header: 'Execution ID',
        cell: (execution: DynamicExecution): JSX.Element =>
            <DynamicExecutionIdLink executionId={execution.executionId}/>,
        sortingField: 'executionId',
    },
    {
        id: 'status',
        header: 'Status',
        cell: (execution: DynamicExecution): JSX.Element => <WorkflowStatusIndicator status={execution.status}/>,
    },
    {
        id: 'clientName',
        header: 'Client Name',
        cell: (execution: DynamicExecution): string => execution.clientName.split(':')[0],
    },
    {
        id: 'rules',
        header: 'Rules',
        cell: (execution: DynamicExecution): JSX.Element => <RulesTableEntry rules={execution.rules} />,
    },
    {
        id: 'startedAt',
        header: 'Started At',
        cell: (execution: DynamicExecution): string | undefined => prettifyDateUTC(execution.createTime),
        sortingComparator: (a: DynamicExecution, b: DynamicExecution): number =>
            compareOptionalDate(a.createTime, b.createTime),
        sortingField: 'startedAt',
    },
    {
        id: 'lastModifiedAt',
        header: 'Last Modified At',
        cell: (execution: DynamicExecution): string | undefined => prettifyDateUTC(execution.lastModifiedTime),
        sortingComparator: (a: DynamicExecution, b: DynamicExecution): number =>
            compareOptionalDate(a.lastModifiedTime, b.lastModifiedTime),
        sortingField: 'lastModifiedAt',
    },
]

export const defaultSortColumn = dynamicExecutionHistoryColumns.length - 1

export const FILTERING_PROPERTIES: PropertyFilterProps.FilteringProperty[] = [
    {
        propertyLabel: 'Execution ID',
        key: 'executionId',
        groupValuesLabel: '',
        operators: operators,
    },
    {
        propertyLabel: 'Execution Status',
        key: 'status',
        groupValuesLabel: 'Execution Status Values',
        operators: operators,
    },
    {
        propertyLabel: 'Execution Client Name',
        key: 'clientName',
        groupValuesLabel: '',
        operators: operators,
    },
    {
        propertyLabel: 'Rules',
        key: 'rules',
        groupValuesLabel: '',
        operators: [':', '!:'] as PropertyFilterOperator[],
        defaultOperator: ':' as PropertyFilterOperator,
    },
]

export const FILTERING_OPTIONS = [
    { 
        propertyKey: 'status', value: WorkflowExecutionStatus.FAILED
    },
    {
        propertyKey: 'status', value: WorkflowExecutionStatus.RUNNING
    },
    {
        propertyKey: 'status', value: WorkflowExecutionStatus.NOT_STARTED
    },
    {
        propertyKey: 'status', value: WorkflowExecutionStatus.SUCCEEDED
    },
]
